import { IApplicationVariableConfiguration } from 'api/digifi/los/layout/VariableConfigurationsApi';
import { LayoutConfigurationEntityName } from 'enums/LayoutConfigurationEntityName';
import { LayoutConfigurationReferenceType } from 'product_modules/enums/LayoutConfigurationReferenceType';

import { createLayoutEntitiesSlice } from './createLayoutEntitiesSlice';

const {
  reducer,
  removeLayoutEntities: removeApplicationDetailsVariables,
} = createLayoutEntitiesSlice<
  IApplicationVariableConfiguration
>({
  referenceType: LayoutConfigurationReferenceType.ApplicationForm,
  layoutConfigurationEntityName: LayoutConfigurationEntityName.Variable,
});

export {
  removeApplicationDetailsVariables,
};

export default reducer;

